import { render, staticRenderFns } from "./apiTurnoverDetail.vue?vue&type=template&id=09ff7a59&scoped=true"
import script from "./apiTurnoverDetail.vue?vue&type=script&lang=js"
export * from "./apiTurnoverDetail.vue?vue&type=script&lang=js"
import style0 from "./apiTurnoverDetail.vue?vue&type=style&index=0&id=09ff7a59&prod&lang=scss"
import style1 from "./apiTurnoverDetail.vue?vue&type=style&index=1&id=09ff7a59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff7a59",
  null
  
)

export default component.exports